export const LandingTrans = {
  english: {
    yoga: "YOGA",
    studio: "STUDIO",
    description: "Yoga doesn't take time, it gives time.",
    once: `Once up on a mat Studio`,
    learnMore: "Learn More",
    hiFriends: "🌿 Hi, friends!",
    myNameIs: `My name is Anya. As a former athlete whose body was damaged by improper training, I know what it's like to live with constant pain. At 16, doctors told me I had "a spine like a grandmother." And at 23, after just a few months of yoga, I completed a 20-kilometer hike — and my life began.`,
    yogaHelped: `Yoga gave me a second chance at my dreams. To travel the world, hike with a backpack, and be free from physical limitations. Almost by accident, my gratitude for this practice and my teachers turned into something I now pass on to others.`,
    iBelieve: `The method I teach is based on knowledge of biomechanics and anatomy, respect for the body's capabilities, and awareness in every movement. Now I know how bodies break — and how they heal. My mission is to help as many people as possible make yoga part of their lives and, as the hippies said, "die young as late as possible." :)`,
    whatIsThisPractice: "What is this practice?",
    practiceDescription: `This is a dynamic Hatha yoga practice where we work not only with the body but also with the state of the mind. If you're unfamiliar with the term, the simplest explanation is that Hatha is the foundation of all physical yoga — all other styles came from it and reflect the vision of individual people. As my teacher says: "Any yoga style limits it, not enhances it — and yoga doesn't deserve that."`,
    duration: "Duration",
    notScary: "1.5 hours. Don't let that scare you.",
    warmup: "Warm-up in the style of Vinyasa yoga",
    mainBlock: "Main block with strength, flexibility, coordination poses",
    shavasana: "Recovery and deep guided Shavasana",
    whoItFits: "Who is it for?",
    newbies: "Beginners",
    regardless: "regardless of physical condition or level. If you can at least even 50% of the practice — you will grow. Want to discuss individual conditions, limitations, or whether group classes are right for you? Call us:",
    pros: "Experienced practitioners",
    forWhom: "For whom yoga isn't confined to a strict school or style. Those open to new experiences, who value a scientific approach over an esoteric one. Those willing to work on where they're weaker, not just where they excel.",
    formats: "Practice Formats",
    liveLessons: "Live Classes",
    liveLessonsDescription: "Living in central Israel? Come to our cozy rooftop studio in Ramat Gan.",
    liveLessonsExtra: "Immerse yourself in a live atmosphere and attentive support from the instructor. Classes every Sunday, Tuesday, and Thursday. Prices range from 25₪ to 70₪ per class depending on subscription.",
    liveLessonsButton: "Book a Trial",
    library: "Library",
    libraryDescription: "An open library of free recordings for self-practice.",
    libraryExtra: "Practice anytime, choose by level, duration, and effect.",
    libraryButton: "Explore",
    club: "Online Club",
    clubDescription: "Need support on your yoga journey? Want to deepen your practice? Join from anywhere in the world!",
    clubExtra: "Each week: a live class + unique recorded practice. Private support chat and sweet bonuses. Monthly subscription – ≈ 50 € (paid as 200₪ or 5000₽).",
    clubButton: "Learn More",
    park: "Park Leumi",
    parkDescription: "Gentle lakeside yoga + coffee and good company. We meet every Friday at 10:00.",
    parkExtra: "Practice, relax, and recharge for the whole weekend. Participation fee – 50₪.",
    parkButton: "Join In",
    reviews: "Reviews",
    prices: "Prices",
    trial: "Trial Session",
    one: "One-Time Visit",
    four: "Once Up on a Mat",
    eight: "Twice Up on a Mat",
    limitless: "Always on the Mat",
    clubDes: "Monthly Subscription",
    trialDes: "First studio session",
    oneDes: "One-time studio session",
    fourDes: "4-session monthly pass",
    eightDes: "8-session monthly pass",
    limitlessDes: "Unlimited monthly studio pass",
    contacts: "Contacts",
    yogaStudio: `Yoga Studio "Once Upon a Mat"`,
    address: "Ramat Gan, Jabotinsky, 103",
    leaveRequest: "Leave a Request",
    yourName: "Your Name",
    yourPhone: "Phone (WhatsApp) or Telegram",
    commentOrQuestion: "Comment or Question",
    sending: "Sending",
    send: "Send",
    // Navbar
    siteName: "Once upon a mat",
    navPractice: "Practice",
    navFormats: "Formats",
    navPrices: "Prices",
    navAbout: "About teacher",
    navContacts: "Contacts",
    navSchedule: "Schedule",
    scheduleSectionLabel: "Schedule",
    scheduleSectionTitle: "Live studio ",
    scheduleSectionTitleEm: "classes",
    signUp: "Book a class",
    menuAria: "Menu",
    formSuccessMessage: "Request sent! We'll get back to you soon.",
    formSuccess: "Message sent!",
    formError: "Server error!",
    // Hero
    heroEyebrow: "Yoga in Russian",
    heroTitle: "Once upon a ",
    heroTitleMat: "mat",
    heroSubtitle: "Hatha yoga in Israel and online — for those who want a practice that evolves. Small groups. In Russian.",
    signUpClass: "Book a class",
    statYears: "years of practice and teaching",
    statFormats: "class formats",
    statFirstClass: "first class",
    heroLocation: "Ramat Gan",
    heroAddress: "Jabotinsky, 103",
    yogaAlt: "Yoga",
    // Why
    whyLabel: "Why here",
    whyTitleEm: "breathe",
    whyTitle: "A place where you can ",
    whyIntro: "Yoga without mysticism or fanaticism — only what really changes how you feel and heals the body.",
    card1Title: "Russian language",
    card1Text: "All classes are in Russian. No language barrier — just practice.",
    card2Title: "Small groups",
    card2Text: "The teacher sees everyone. Individual approach and adjustments for your body.",
    card3Title: "Any level",
    card3Text: "If you can do at least 50% of the practice — you will grow.",
    card4Title: "Body and state of mind",
    card4Text: "We work not only with the body but also with the nervous system. Yoga as a tool for life.",
    // Safety
    safetyTitle: "The studio is a protected room (mamad)",
    safetyText: "In the current situation this matters. The studio is on the ground floor and is a reinforced space where you can practice in peace. Classes are not interrupted by alerts. And the nearest metro is 5 minutes away.",
    // Formats
    formatsLabel: "Formats",
    formatsTitleEm: "your",
    formatsTitle: "Find ",
    formatsTitleSuffix: " format",
    formatsIntro: "In-studio classes, in the park by the lake, or online from anywhere in the world.",
    formatLiveTitle: "In-person classes",
    formatLiveDesc: "Studio in Ramat Gan. Cozy atmosphere, small groups.",
    formatLivePrice: "Protected room (mamad). Groups up to 8 people. 25₪–70₪ per class.",
    formatLiveLink: "Schedule →",
    formatParkTitle: "Park Leumi",
    formatParkDesc: "Practice in the park by the lake every Friday morning.",
    formatParkPrice: "Softer practice, 60 minutes. Coffee and company afterwards :)",
    formatParkLink: "Join →",
    formatClubTitle: "Online club",
    formatClubDesc: "Online access to all studio classes + practice builder.",
    formatClubPrice: "Practice builder, library, unlimited online access to studio classes + support chat.",
    formatClubLink: "Learn more →",
    formatLibraryTitle: "Open library",
    formatLibraryDesc: "Free library of recordings for self‑practice.",
    formatLibraryPrice: "Practice by yourself. Choose by level, duration and focus.",
    toLibrary: "To library →",
    formatsCta: "Not sure where to start? First studio class — 50₪. Come, feel the format, meet the group.",
    // Practice
    practiceLabel: "About the practice",
    practiceTitleEm: "Hatha yoga",
    practiceTitle: "What is ",
    practiceIntro: "This is a dynamic practice where we work not only with the body but also with the state of the mind. If the term is new to you, the simplest explanation is that Hatha is all physical yoga — every other style grew from it and reflects one person's vision. As my teacher says:",
    practiceQuote: "\"Any yoga style limits it rather than enhances it — and it doesn't deserve that.\"",
    whoFits: "Who is it for?",
    newbiesBox: "Beginners",
    newbiesText: "Regardless of physical condition or level. If you can do at least 50% of the practice, you will grow. We can discuss individual needs and limitations before you start.",
    prosBox: "Advanced",
    prosText: "For whom yoga isn't confined to one school or style. For those open to new experience, who value a scientific approach over an esoteric one. Who are willing to work on weak spots, not only strengths.",
    structureLabel: "Class structure · 1.5 hours",
    warmupItem: "Warm-up in Vinyasa style — a soft entry into practice",
    mainItem: "Main block — strength, flexibility and coordination asanas",
    shavasanaItem: "Recovery and deep guided Shavasana",
    callUs: "Call if you have questions",
    whatsappTelegram: "WhatsApp / Telegram",
    // Pricing
    pricesLabel: "Prices",
    pricesTitleEm: "your",
    pricesTitle: "Choose ",
    pricesTitleSuffix: " format",
    pricesNote: "Pass is valid for one month from activation",
    badgeTrial: "First step",
    badgeOne: "Single",
    badgeClub: "Online",
    badgeFour: "Pass",
    badgeEight: "Popular",
    badgeLimitless: "Unlimited",
    trialName: "Trial class",
    oneName: "Single visit",
    clubName: "Online club",
    fourName: "Once up on the mat",
    eightName: "Twice up on the mat",
    limitlessName: "Always on the mat",
    trialDesc: "First studio class",
    oneDesc: "Single studio class",
    clubDesc: "Monthly subscription",
    fourDesc: "4 studio classes / month",
    eightDesc: "8 studio classes / month",
    limitlessDesc: "Unlimited visits / month",
    perSubscription: "*with subscription",
    pricingFooter: "Not for you? You can pass the pass to a friend or return it. Questions? WhatsApp: ",
    // About
    aboutLabel: "About Anya",
    aboutTitleEm: "Hi,",
    aboutTitle: " I'm Anya",
    aboutP1: "At 23 my back finally stopped working as a back, after years of acrobatics as a child. While my peers were living their best lives, I could barely walk a kilometer and spent most of my time at home, crying from pain. It felt like the end, but it was the start of a beautiful path. With yoga I recovered fully without surgery. And to learn how to never fall apart again, I did a teacher training — after telling my teacher I would never teach :)",
    aboutQuote: "Yoga gave me a second chance at my dreams — to travel the world, hike with a backpack, and be free from physical limits.",
    aboutP2: "Almost by accident, my gratitude for this practice and my teachers turned into what I now pass on to others.",
    aboutP3: "Now I know how bodies break and how they heal. My mission is to help as many people as possible make yoga part of their lives. And as the hippies said:",
    hippieQuote: "\"Die young as late as possible\" :)",
    anyaAlt: "Anya",
    // How to
    howToLabel: "How to book",
    howToTitleEm: "first class",
    howToTitle: "Three steps to your ",
    step1Title: "Choose format and time",
    step1Text: "Go to the schedule and pick a class that works for you.",
    step2Title: "Get in touch",
    step2Text: "I'll reach out (message or call). We'll discuss your questions, limitations and what to expect.",
    step3Title: "Come to your first",
    step3Text: "Trial class — 50₪. Feel the format, meet the group. No commitment.",
    whatsappButton: "Message on WhatsApp",
    confirmationNote: "Confirmation comes right after payment.",
    // Contact
    contactLabel: "Contacts",
    contactTitleEm: "us",
    contactTitle: "Get in touch with ",
    addressLabel: "Address",
    addressSub: "Studio-mamad (protected room)",
    whatsappLabel: "WhatsApp",
    emailLabel: "Email",
    instagramLabel: "Instagram",
    studioBtn: "Studio",
    parkBtn: "Park Leumi",
    locationStudio: "Studio · Jabotinsky, 103",
    locationPark: "Park Leumi · classes by the lake",
    // TestimonialStrip aria
    prevReview: "Previous review",
    nextReview: "Next review",
    reviewOf: "Review ",
  },
  russian: {
    yoga: "ЙОГА",
    studio: "СТУДИЯ",
    description: "Йога на русском языке в Израиле и онлайн.",
    once: "Однажды",
    uponamat: "на коврике",
    learnMore: "Узнать больше",
    hiFriends: "🌿 Привет, друзья!",
    myNameIs: `Меня зовут Аня. Как бывший травмированный спортсмен, я знаю, какого это жить с постоянной болью.`,
    yogaHelped: `Йога дала мне второй шанс на мечты - путешествовать по миру, ходить в походы под рюкзаком и быть свободной от телесных ограничений. Почти случайно моя благодарность к этой практике и моим учителям переткла в то, что теперь я передаю эти знания дальше.`,
    iBelieve: `Теперь я знаю, как тела ломаются и как собираются. А моя миссия - сделать так, чтобы как можно больше людей сделали йогу частью своей жизни и, как говорили хиппи, - ״умерли молодыми как можно позже״ :)`,
    whatIsThisPractice: "Что это за практика?",
    practiceDescription: `Это динамичная практика Хатха йоги, в которой мы работаем не только с телом, но и с состоянием ума. Если этот термин вам не знаком, то самое просто объяснение это, что Хатха - вся физическая йога, а все остальные стили вышли из неё и являются видением одного человека. Как говорит мой учитель: "Любой стиль йоги ограничивает её, а не дополняет, и она этого не заслуживает".`,
    duration: "Продолжительность",
    notScary: "1,5 часа. Пусть это вас не пугает.",
    warmup: "Разминка в стиле виньяса йоги",
    mainBlock: "Основная часть с силовыми, гибкостными и координационными асанами",
    shavasana: "Восстановление и глубокая шавасана с сопровождением",
    whoItFits: "Кому она подходит?",
    newbies: "Новичкам",
    regardless: "вне зависимости от физического состояния и уровня. Если вы можете выполнить хотя бы 50% практики, вы будете расти. Если вы хотите обсудить индивидуальные особенности, ограничения и узнать, насколько вам подходит групповая практика, не стесняйтесь звонить: ",
    pros: "Продвинутым практикам",
    forWhom: ", для которых йога не ограничивается строгой школой или стилем. Тем, кто открыт к новому опыту, ценит научный подход, а не эзотерический. Кто готов работать над тем, где отстаёт, а не только над тем, в чём уже хорош.",
    formats: "Форматы занятий",
    liveLessons: "Очные занятия",
    liveLessonsDescription: "Живёте в центре Израиля? Приходите в нашу уютную студию в Рамат-Гане.",
    liveLessonsExtra: "Погружение в живую атмосферу и внимательная поддержка преподавателя. Стоимость от 25₪ до 70₪ за занятие в зависимости от абонемента.",
    liveLessonsButton: "Расписание и запись",
    library: "Библиотека",
    libraryDescription: "Открытая библиотека бесплатных записей для самостоятельной практики.",
    libraryExtra: "Практикуйте в удобное для вас время, выбирайте практику по уровню, времени и типу воздействия.",
    libraryButton: "Открыть",
    club: "Онлайн клуб",
    clubDescription: "Нужна поддержка на пути освоения йоги? Не хвататет развития в практике? Подключайтесь из любой точки мира!",
    clubExtra: "Каждую неделю встречаемся на практику онлайн + уникальная пратика в записи. Закрытый чат поддержки и приятные бонусы. Подписка на месяц — ≈ 50 € (к оплате 200₪ или 5000₽).",
    clubButton: "Узнать больше",
    park: "Парк Леуми",
    parkDescription: "Мягкая практика йоги у озера + кофе и копмания. Встречаемся каждую пятницу в 09:30.",
    parkExtra: "Практикуем, отдыхаем и заряжаемся на все выходные. Стоимость участия - 50₪.",
    parkButton: "Присоединиться",
    reviews: "Отзывы",
    prices: "Цены",
    trial: "Пробное занятие",
    one: "Разовое посещение",
    four: "Однажды на коврике",
    eight: "Дважды на коврике",
    limitless: "Постоянно на коврике",
    clubDes: "Месячная подписка",
    trialDes: "Первое занятие в студии",
    oneDes: "Разовое занятие в студии",
    fourDes: "Абонемент на 4 занятия в студии в течение месяца",
    eightDes: "Абонемент на 8 занятий в студии в течение месяца",
    limitlessDes: "Безлимитное посещение студии в течение месяца",
    contacts: "Контакты",
    yogaStudio: `Студия йоги "Однажды на коврике"`,
    address: "Рамат-Ган, Жаботински, 103",
    leaveRequest: "Оставить заявку",
    yourName: "Ваше имя",
    yourPhone: "Телефон (WhatsApp) или Telegram",
    commentOrQuestion: "Комментарий или вопрос",
    sending: "Отправялется",
    send: "Отправить",
    // Navbar
    siteName: "Однажды на коврике",
    navPractice: "О практике",
    navFormats: "Форматы",
    navPrices: "Цены",
    navAbout: "О преподавателе",
    navContacts: "Контакты",
    navSchedule: "Расписание",
    scheduleSectionLabel: "Расписание",
    scheduleSectionTitle: "Расписание занятий в студии и ",
    scheduleSectionTitleEm: "онлайн трансляций",
    signUp: "Записаться",
    menuAria: "Меню",
    formSuccessMessage: "Заявка отправлена! Мы свяжемся с вами скоро.",
    formSuccess: "Сообщение отправлено!",
    formError: "Ошибка сервера!",
    // Hero
    heroEyebrow: "Йога на русском языке",
    heroTitle: "Однажды на ",
    heroTitleMat: "коврике",
    heroSubtitle: "Хатха-йога в Израиле и онлайн — для тех, кто хочет развивающей практики. Маленькие группы. На русском языке.",
    signUpClass: "Записаться на занятие",
    statYears: "года практики и преподавания",
    statFormats: "формата занятий",
    statFirstClass: "первое занятие",
    heroLocation: "Рамат-Ган",
    heroAddress: "Жаботински, 103",
    yogaAlt: "Йога",
    // Why
    whyLabel: "Почему именно здесь",
    whyTitleEm: "выдохнуть",
    whyTitle: "Место, где можно ",
    whyIntro: "Йога без эзотерики и фанатизма — только то, что реально меняет самочувствие и исцеляет тело.",
    card1Title: "Русский язык",
    card1Text: "Все занятия ведутся на русском. Никакого языкового барьера — только практика.",
    card2Title: "Маленькие группы",
    card2Text: "Преподаватель видит каждого. Индивидуальный подход и отстройки для вашего тела.",
    card3Title: "Любой уровень",
    card3Text: "Если вы можете выполнить хотя бы 50% практики — вы будете расти.",
    card4Title: "Тело и состояние ума",
    card4Text: "Работаем не только с телом, но и с нервной системой. Йога как инструмент к жизни.",
    // Safety
    safetyTitle: "Студия — это защищённая комната (мамад)",
    safetyText: "В нынешней ситуации это важно. Студия на первом этаже и укреплённое помещение, где можно практиковать спокойно. Занятия не прерываются из-за тревог. А до ближайшего метро - 5 минут.",
    // Formats
    formatsLabel: "Форматы",
    formatsTitleEm: "свой",
    formatsTitle: "Найдите ",
    formatsTitleSuffix: " формат",
    formatsIntro: "Очно в студии, в парке у озера или онлайн из любой точки мира.",
    formatLiveTitle: "Очные занятия",
    formatLiveDesc: "Студия в Рамат-Гане. Уютная атмосфера, маленькие группы.",
    formatLivePrice: "Студия - защищенная комната. Группы до 8 человек. От 25₪ до 70₪ за занятие",
    formatLiveLink: "Расписание →",
    formatParkTitle: "Парк Леуми",
    formatParkDesc: "Практика в парке у озера каждое пятничное утро.",
    formatParkPrice: "Более мягкая практика. 60 минут. И кофе с компанией после :)",
    formatParkLink: "Присоединиться →",
    formatClubTitle: "Онлайн клуб",
    formatClubDesc: "Онлайн доступ ко всем занятиям студии + конструктор.",
    formatClubPrice: "Конструктор практик, библиотека, безлимитное онлайн подключение к занятиям студии + чат поддержки.",
    formatClubLink: "Узнать больше →",
    formatLibraryTitle: "Открытая библиотека",
    formatLibraryDesc: "Бесплатная библиотека записей для самостоятельной практики.",
    formatLibraryPrice: "Занимайтесь самостоятельно. Выбирайте по уровню, длительности и типу воздействия.",
    toLibrary: "В библиотеку →",
    formatsCta: "Не уверены с чего начать? Первое занятие в студии — 50₪. Приходите, почувствуйте формат, познакомьтесь с группой.",
    // Practice
    practiceLabel: "О практике",
    practiceTitleEm: "Хатха-йога",
    practiceTitle: "Что такое ",
    practiceIntro: "Это динамичная практика, в которой мы работаем не только с телом, но и с состоянием ума. Если этот термин вам не знаком, то самое просто объяснение это, что Хатха - вся физическая йога, а все остальные стили вышли из неё и являются видением одного человека. Как говорит мой учитель:",
    practiceQuote: "«Любой стиль йоги ограничивает её, а не дополняет, и она этого не заслуживает»",
    whoFits: "Кому она подойдет?",
    newbiesBox: "Новичкам",
    newbiesText: "Вне зависимости от физического состояния и уровня. Если вы можете выполнить хотя бы 50% практики, вы будете расти. Обсудим индивидуальные особенности и ограничения перед началом.",
    prosBox: "Продвинутым",
    prosText: "Для которых йога не ограничивается строгой школой или стилем. Тем, кто открыт к новому опыту, ценит научный подход, а не эзотерический. Кто готов работать над тем, где отстаёт, а не только над тем, в чём уже хорош.",
    structureLabel: "Структура занятия · 60-90 минут",
    warmupItem: "Разминка в стиле виньяса-йоги — мягкий вход в практику",
    mainItem: "Основная часть — силовые, гибкостные и координационные асаны",
    shavasanaItem: "Восстановление и глубокая шавасана с сопровождением",
    callUs: "Звоните, если есть вопросы",
    whatsappTelegram: "WhatsApp / Telegram",
    // Pricing
    pricesLabel: "Цены",
    pricesTitleEm: "свою",
    pricesTitle: "Выберите ",
    pricesTitleSuffix: " интенсивность",
    pricesNote: "Абонемент действителен в течение месяца после активации",
    badgeTrial: "Первый шаг",
    badgeOne: "Разовое",
    badgeClub: "Онлайн",
    badgeFour: "Абонемент",
    badgeEight: "Популярный",
    badgeLimitless: "Безлимит",
    trialName: "Пробное занятие",
    oneName: "Разовое посещение",
    clubName: "Онлайн клуб",
    fourName: "Однажды на коврике",
    eightName: "Дважды на коврике",
    limitlessName: "Постоянно на коврике",
    trialDesc: "Первое занятие в студии",
    oneDesc: "Разовое занятие в студии",
    clubDesc: "Месячная подписка",
    fourDesc: "4 занятия в студии / месяц",
    eightDesc: "8 занятий в студии / месяц",
    limitlessDesc: "Безлимитное посещение / месяц",
    perSubscription: "*по подписке",
    pricingFooter: "Не подошло — абонемент можно передать подруге или вернуть. Есть вопросы? Пишите в WhatsApp: ",
    // About
    aboutLabel: "О преподавателе",
    aboutTitleEm: "Привет,",
    aboutTitle: " я — Аня",
    aboutP1: "В 23 года моя спина окончательно отказалась работать спиной, что было последствием акробатики в детстве. Пока мои сверстинки жили свою лучшую жизнь, я едва могла пройти километр и большую часть времени лежала дома, рыдая от боли. Мне казалось, это конец, но это было началом прекрасного пути. С помощью йоги мне удалось полностью восстановиться без хирургического вмешательства. А чтобы узнать как больше никогда не развалиться, я пошла на преподвательский курс, предупредив моего учителя, что преподавать я точно не буду :)",
    aboutQuote: "Йога дала мне второй шанс на мечты — путешествовать по миру, ходить в походы под рюкзаком и быть свободной от телесных ограничений.",
    aboutP2: "Почти случайно моя благодарность к этой практике и моим учителям перетекла в то, что теперь я передаю эти знания дальше.",
    aboutP3: "Теперь я знаю, как тела ломаются и как собираются. А моя миссия — сделать так, чтобы как можно больше людей сделали йогу частью своей жизни. И как говорили хиппи:",
    hippieQuote: "«Умерли молодыми как можно позже» :)",
    anyaAlt: "Аня",
    // How to
    howToLabel: "Как записаться",
    howToTitleEm: "первого занятия",
    howToTitle: "Три шага до ",
    step1Title: "Выберите формат и время",
    step1Text: "Перейдите на страницу расписания и выберите подходящее вам занятие.",
    step2Title: "Связь и обсуждение",
    step2Text: "Я свяжусь с вами (сообщением или звонком). Обсудим вопросы, ограничения и чего ожидать.",
    step3Title: "Приходите на пробное",
    step3Text: "Пробное занятие — 50₪. Почувствуйте формат, познакомьтесь с группой. Без обязательств.",
    whatsappButton: "Написать в WhatsApp",
    confirmationNote: "Подтверждение придёт сразу после оплаты.",
    // Contact
    contactLabel: "Контакты",
    contactTitleEm: "нами",
    contactTitle: "Свяжитесь с ",
    addressLabel: "Адрес",
    addressSub: "Студия-мамад (защищённая комната)",
    whatsappLabel: "WhatsApp",
    emailLabel: "Email",
    instagramLabel: "Instagram",
    studioBtn: "Студия",
    parkBtn: "Парк Леуми",
    locationStudio: "Студия · Жаботински, 103",
    locationPark: "Парк Леуми · занятия у озера",
    // TestimonialStrip aria
    prevReview: "Предыдущий отзыв",
    nextReview: "Следующий отзыв",
    reviewOf: "Отзыв ",
  },
};

/** /links page — main CTA button labels */
export const SocialHubTrans = {
  english: {
    greeting: "Hi, I'm Anya",
    tagline:
      "I travel in a camper van, teach yoga online, and build unique products for practitioners and teachers.",
    studio: "Studio in Ramat Gan",
    individual: "Individual sessions",
    onlineClubTitle: "Online yoga club",
    onlineClubDesc: "Regular live streams and a video library",
    onlineClubPrice: "€59 / month",
    individualDesc: "Tailored to your goals",
    individualPrice: "€200–500 / month",
    tendsLink: "Booking system",
    tendsDesc: "Client management, calendar and business tracking",
    tendsPrice: "€25–45 / month",
    practiceSectionTitle: "Practice with me",
    businessSectionTitle: "For entrepreneurs",
    secondarySectionTitle: "For students",
    scheduleCta: "Schedule",
    cabinetCta: "Log in",
  },
  russian: {
    greeting: "Привет, я Аня",
    tagline:
      "Преподаю йогу, путешествую в автодоме и создаю инструменты для предпринимателей.",
    studio: "Студия в Рамат Гане",
    individual: "Индивидуальные занятия",
    onlineClubTitle: "Онлайн-клуб йоги",
    onlineClubDesc: "Регулярные трансляции и библиотека",
    onlineClubPrice: "€59 / месяц",
    individualDesc: "Работаем под ваш запрос",
    individualPrice: "€200–500 / месяц",
    tendsLink: "Система для записи",
    tendsDesc: "Организация клиентов, календарь и отслеживание бизнеса",
    tendsPrice: "€25–45 / месяц",
    practiceSectionTitle: "Практиковать со мной",
    businessSectionTitle: "Для предпринимателей",
    secondarySectionTitle: "Для своих",
    scheduleCta: "Запись",
    cabinetCta: "Войти в лк",
  },
};

export const OnlineClubTrans = {
  english: {
    yoga: "YOGA",
    studio: "STUDIO",
    description: "Yoga doesn't take time, it gives time.",
    once: "Once up on a ",
    uponamat: "mat",
    onceSuffix: " Studio",
    onlineClub: "Online club",
    learnMore: "Learn More",
    hiFriends: "🌿 Hi, friends!",
    myNameIs: `My name is Anya. As a former athlete whose body was damaged by improper training, I know what it's like to live with constant pain. At 16, doctors told me I had "a spine like a grandmother." And at 23, after just a few months of yoga, I completed a 20-kilometer hike — and my life began.`,
    yogaHelped: `Yoga gave me a second chance at my dreams. To travel the world, hike with a backpack, and be free from physical limitations. Almost by accident, my gratitude for this practice and my teachers turned into something I now pass on to others.`,
    iBelieve: `The method I teach is based on knowledge of biomechanics and anatomy, respect for the body's capabilities, and awareness in every movement. Now I know how bodies break — and how they heal. My mission is to help as many people as possible make yoga part of their lives and, as the hippies said, "die young as late as possible." :)`,
    whatIsThisPractice: "What is this practice?",
    practiceDescription: `This is a dynamic Hatha yoga practice where we work not only with the body but also with the state of the mind. If you're unfamiliar with the term, the simplest explanation is that Hatha is the foundation of all physical yoga — all other styles came from it and reflect the vision of individual people. As my teacher says: "Any yoga style limits it, not enhances it — and yoga doesn't deserve that."`,
    duration: "Duration",
    notScary: "1.5 hours. Don't let that scare you.",
    warmup: "Warm-up in the style of Vinyasa yoga",
    mainBlock: "Main block with strength, flexibility, coordination poses",
    shavasana: "Recovery and deep guided Shavasana",
    whoItFits: "Who is it for?",
    newbies: "Beginners",
    regardless: "Regardless of physical condition or level. If you can at least even 50% of the practice — you will grow. Want to discuss individual conditions, limitations, or whether group classes are right for you? Call us:",
    pros: "Experienced practitioners",
    forWhom: "For whom yoga isn't confined to a strict school or style. Those open to new experiences, who value a scientific approach over an esoteric one. Those willing to work on where they're weaker, not just where they excel.",
    formats: "What's included in the subscription?",
    formatsTitle: "What's included in the ",
    formatsTitleEm: "subscription?",
    formatsDescription: "Each week you receive:",
    liveLessons: "Online classes",
    liveLessonsDescription: "Online access to all studio classes.",
    liveLessonsExtra: "Join with your camera on and a readable name so I can address you personally and help you build a safe, effective practice.",
    liveLessonsButton: "Schedule",
    library: "Library",
    libraryDescription: "Choose a practice by level, duration and focus.",
    libraryExtra: "Recorded practices from 15 to 90 minutes: strength work, restorative flows, and educational tutorials.",
    libraryButton: "Open a sample",
    constructor: "Practice builder",
    constructorDescription: "Want to choose what to work on? Build a practice for yourself.",
    constructorExtra: "With a trained algorithm you can create a sequence that stays safe and effective while you pick intensity, length and focus.",
    constructorButton: "Open a sample",
    constructorFeaturedBadge: "Only here",
    chat: "Support chat",
    chatDescription: "Have questions or want to share your results?",
    chatExtra: "A private support chat for studio clients. We talk about yoga details, health and lifestyle.",
    chatButton: "And this is the public chat :)",
    reviews: "Reviews",
    prices: "Prices",
    trial: "Trial Class",
    one: "Single Visit",
    four: "Once up on the Mat",
    eight: "Twice up on the Mat",
    limitless: "Always on the Mat",
    clubDes: "Monthly Subscription",
    trialDes: "First class at the studio",
    oneDes: "Single studio class",
    fourDes: "4-class studio pass (valid one month)",
    eightDes: "8-class studio pass (valid one month)",
    limitlessDes: "Unlimited studio access (one month)",
    contacts: "Contacts",
    perMonth: "per month",
    singlePass: "single class",
    joinCta: "Join",
    whoItFitsTitle: "Who is it ",
    whoItFitsTitleEm: "for?",
    readyToTry: "Ready to try?",
    readyToTryTitle: "Ready ",
    readyToTryTitleEm: "to try?",
    aboutClub: "About the club",
    aboutClubTitle: "About the ",
    aboutClubTitleEm: "club",
    aboutClubDescription: `This project started almost by accident. Through my Instagram blog I wanted to invite people to in‑person classes in Israel. Some came – about 2.5% of followers. The other 97.5% were Russian‑speaking people from all over the world asking for online classes. So the idea of \"someday going online\" turned into a goal for the very next month. Thank you for that push ❤️`,
    value: "Values",
    valueDescription: "In online classes I can’t adjust you with my hands, so having the camera on is essential. I believe hands are the last resource of a yoga teacher. A teacher should be able to explain everything even without demonstrating – with voice, words and attention. This is what I’m aiming for, and your safety is always my first priority. Right after that comes the effectiveness of your practice.",
    yogaStudio: `Once Upon a Mat Yoga Studio`,
    address: "Ramat Gan, Jabotinsky, 103",
    leaveRequest: "Leave a Request",
    yourName: "Your Name",
    yourPhone: "Phone (WhatsApp or Telegram)",
    commentOrQuestion: "Comment or Question",
    sending: "Sending",
    send: "Send",
    scheduleSectionHeadingTitle: "Online livestream schedule",
  },
  russian: {
    yoga: "ЙОГА",
    studio: "СТУДИЯ",
    description: "Занимайтесь из любой точки мира, в своём ритме.",
    once: "Однажды",
    uponamat: "на коврике",
    onceSuffix: "",
    onlineClub: "Онлайн клуб",
    learnMore: "Узнать больше",
    aboutClub: "О клубе",
    aboutClubTitle: "О ",
    aboutClubTitleEm: "клубе",
    aboutClubDescription: `Этот проект возник случайно. С помощью блога в инстаграм я хотела привлечь учеников на живые занятия в Израиле. Они пришли, 2,5% подписчиков. Остальные 97,5% оказались русскоязычными людьми со всего мира, спрашивающими об онлайн уроках. Так идея "когда-нибудь выйти в онлайн" стала целью на ближайший месяц. Спасибо вам за этот пинок ❤️`,
    value: "Ценности",
    valueDescription: "Править вас в живую возможности у меня не будет, поэтому включенная камера на онлайн занятиях обязательна. Я верю, что руки - это последний ресурс преподавателя йоги. Учитель должен уметь объяснить всё, даже не показывая на себе, - инструкциями, голосом, вглядом. По крайней мере к этому я стремлюсь, и ваша безопасность для меня на первом месте. На слеующем - эффективность практики.",
    whatIsThisPractice: "Что это за практика?",
    practiceDescription: `Это динамичная практика Хатха йоги, в которой мы работаем не только с телом, но и с состоянием ума. Если этот термин вам не знаком, то самое просто объяснение это, что Хатха - вся физическая йога, а все остальные стили вышли из неё и являются видением одного человека. Как говорит мой учитель: "Любой стиль йоги ограничивает её, а не дополняет, и она этого не заслуживает".`,
    duration: "Продолжительность",
    notScary: "1,5 часа. Пусть это вас не пугает.",
    warmup: "Разминка в стиле виньяса йоги",
    mainBlock: "Основная часть с силовыми, гибкостными и координационными асанами",
    shavasana: "Восстановление и глубокая шавасана с сопровождением",
    beginners: "Новички",
    whoItFits: "Кому подойдёт онлайн клуб?",
    whoItFitsTitle: "Кому подойдёт ",
    whoItFitsTitleEm: "онлайн клуб?",
    newbies: "Новичкам",
    regardless: "Вне зависимости от физического состояния и уровня. Если вы цените научный подход, а не эзотерический. Готовы трудиться и преодалевать себя, вам понравится. Если вы хотите обсудить индивидуальные особенности, ограничения и узнать, насколько вам подходит групповая практика, не стесняйтесь звонить: +972 055 91 69 75",
    pros: "Продвинутым практикам",
    forWhom: "Для которых йога не ограничивается строгой школой или стилем. Тем, кто открыт к новому опыту и ценит научный подход. Кто готов работать над тем, где отстаёт, а не только над тем, в чём уже хорош.",
    formats: "Что входит в подписку?",
    formatsTitle: "Что входит в ",
    formatsTitleEm: "подписку?",
    formatsDescrition: "Каждую неделю вы получаете:",
    liveLessons: "Онлайн занятия",
    liveLessonsDescription: "Онлайн доступ ко всем занятиям студии.",
    liveLessonsExtra: "Подключайтесь со включенной камерой и читабельным именем, чтобы я могла обратиться к вам лично и помочь выстроить безопасную и эффективную практику.",
    liveLessonsButton: "Расписание",
    library: "Библиотека",
    libraryDescription: "Выбирайте практику по уровню, длительности и типу воздействия.",
    libraryExtra: "Практики в записи длительностью от 15 до 90 минут. Силовые, восстанавливающие практики, а так же обучающие туториалы.",
    libraryButton: "Открыть пример",
    constructor: "Конструктор",
    constructorDescription: "Хочешь сам выбирать над чем поработать? Сделай практику под себя!",
    constructorExtra: "С помощью обученного алгоритма ты сможешь создать практику, сохранив безопасность и эффективность последовательности. Ты сам выберешь степень нагрузки, длительность и акцент занятия!",
    constructorButton: "Открыть пример",
    constructorFeaturedBadge: "Только у нас",
    chat: "Чат поддержки",
    chatDescription: "Появились вопросы или хочется поделиться результатом?",
    chatExtra: "Закрытый чат поддержки для клиентов студии. Обсудим тонкости йоги, здоровье и образ жизни",
    chatButton: "А здесь открытый чат :)",
    reviews: "Отзывы",
    prices: "Цены",
    trial: "Пробное занятие",
    one: "Разовое посещение",
    four: "Однажды на коврике",
    eight: "Дважды на коврике",
    limitless: "Постоянно на коврике",
    clubDes: "Месячная подписка",
    trialDes: "Первое занятие в студии",
    oneDes: "Разовое занятие в студии",
    fourDes: "Абонемент на 4 занятия в студии в течение месяца",
    eightDes: "Абонемент на 8 занятий в студии в течение месяца",
    limitlessDes: "Безлимитное посещение студии в течение месяца",
    contacts: "Контакты",
    perMonth: "в месяц",
    singlePass: "разовое занятие",
    joinCta: "Вступить",
    readyToTry: "Готовы попробовать?",
    readyToTryTitle: "Готовы ",
    readyToTryTitleEm: "попробовать?",
    yogaStudio: `Студия йоги "Однажды на коврике"`,
    address: "Рамат-Ган, Жаботински, 103",
    leaveRequest: "Оставить заявку",
    yourName: "Ваше имя",
    yourPhone: "Телефон (WhatsApp) или Telegram",
    commentOrQuestion: "Комментарий или вопрос",
    sending: "Отправялется",
    send: "Отправить",
    scheduleSectionHeadingTitle: "Расписание онлайн трансляций",
  },
};

export const HeaderTrans = {
  english: {
    onceUp: "ONCE UP",
    onMat: "ON A MAT",
    about: "ABOUT",
    login: "LOG IN",
    logout: "LOG OUT",
    library: "LIBRARY",
    onlineSessions: "ONLINE TRANSLATIONS",
    constructor: "CONSTRUCTOR",
    shop: "GOODIES",
    contact: "CONTACT",
    liveSessions: "IN-PERSON CLASSES",
    blog: "BLOG",
    schedule: "SCHEDULE",
    studio: "STUDIO",
    aboutUs: "ABOUT US",
    aboutPractice: "ABOUT THE PRACTICE",
    prices: "PRICES",
    reviews: "REVIEWS",
    contacts: "CONTACTS",
    classes: "CLASS FORMATS",
    lives: "LIVES",
    admin: "Dashboard",
    courses: "COURSES",
  },
  russian: {
    onceUp: "ОДНАЖДЫ",
    onMat: "НА КОВРИКЕ",
    about: "О СТУДИИ",
    login: "ВОЙТИ",
    logout: "ВЫЙТИ",
    library: "БИБЛИОТЕКА",
    onlineSessions: "ОНЛАЙН ТРАНСЛЯЦИИ",
    constructor: "КОНСТРУКТОР",
    shop: "НИШТЯКИ",
    contact: "КОНТАКТЫ",
    liveSessions: "ЖИВЫЕ ЗАНЯТИЯ",
    blog: "БЛОГ",
    schedule: "РАСПИСАНИЕ",
    studio: "СТУДИЯ",
    aboutUs: "О НАС",
    aboutPractice: "О ПРАКТИКЕ",
    prices: "ЦЕНЫ",
    reviews: "ОТЗЫВЫ",
    contacts: "КОНТАКТЫ",
    classes: "ФОРМАТЫ ЗАНЯТИЙ",
    lives: "ТРАНСЛЯЦИИ",
    aboutClub: "О КЛУБЕ",
    whatsIncluded: "ЧТО ВХОДИТ",
    whomFor: "КОМУ ПОДХОДИТ",
    admin: "Дашборд",
    courses: "КУРСЫ",
  },
};

export const CoursesTrans = {
  english: {
    title: "Courses",
    loading: "Loading courses...",
    error: "Failed to load courses.",
    classes: "classes",
    open: "Open course",
    buy: "Buy course",
    locked: "Locked",
    unlocked: "Unlocked",
  },
  russian: {
    title: "Курсы",
    loading: "Загружаем курсы...",
    error: "Не удалось загрузить курсы.",
    classes: "классов",
    open: "Открыть курс",
    buy: "Купить курс",
    locked: "Закрыто",
    unlocked: "Открыто",
  },
};

export const CourseClassDetailTrans = {
  english: {
    loading: "Loading class...",
    error: "Failed to load class.",
    materials: "Materials",
    images: "Images",
    textContent: "Notes",
    watchOnYoutube: "Watch on YouTube",
    openPdf: "Open PDF",
    backToCourse: "Back to course",
    locked: "This course is locked",
    lockedHint: "Studio and Online Club members get free access. Everyone else can purchase this course.",
    loginToBuy: "Log in to purchase",
    choosePayment: "Choose a payment method",
    buyWithAllpay: "Pay with Allpay",
    buyWithYookassa: "Pay with YooKassa",
    purchaseError: "Failed to start payment. Please try again.",
    redirecting: "Redirecting to payment...",
    stillProcessingTitle: "Still confirming your payment",
    stillProcessingBody: "This can take a minute. If the course hasn't unlocked yet, check your email for a receipt, or refresh to check again.",
    refresh: "Refresh",
    checking: "Checking...",
  },
  russian: {
    loading: "Загружаем занятие...",
    error: "Не удалось загрузить занятие.",
    materials: "Материалы",
    images: "Изображения",
    textContent: "Заметки",
    watchOnYoutube: "Смотреть на YouTube",
    openPdf: "Открыть PDF",
    backToCourse: "Назад к курсу",
    locked: "Этот курс закрыт",
    lockedHint: "Участники Studio и Online Club получают доступ бесплатно. Остальные могут купить курс.",
    loginToBuy: "Войдите, чтобы купить",
    choosePayment: "Выберите способ оплаты",
    buyWithAllpay: "Оплатить через Allpay",
    buyWithYookassa: "Оплатить через ЮKassa",
    purchaseError: "Не удалось начать оплату. Попробуйте ещё раз.",
    redirecting: "Переходим к оплате...",
    stillProcessingTitle: "Всё ещё подтверждаем оплату",
    stillProcessingBody: "Обычно это занимает не больше минуты. Если курс всё ещё не открылся, проверьте почту — там должен быть чек, или нажмите «Обновить», чтобы проверить ещё раз.",
    refresh: "Обновить",
    checking: "Проверяем...",
  },
};

export const LibraryTrans = {
  english: {
    header: "Library",
    workouts: "Practices",
    lectures: "Lectures",
    courses: "Courses",
    lives: "Lives",
    blog: "Articles",
    becomeMember: "Become a member to get access to more",
    coffee: "Monthly subsciption at the price of 2 coffee cups :)",
    saved: "Saved Practices",
    loginToSeeSaved: "Log in to see your saved practices.",
    noSavedYet: "You have no saved practices yet.",
    browseLibrary: "Browse the library",
    toSaveSome: "to save some.",
    noMatchFilters: "No saved practices match the current filters.",
  },
  russian: {
    header: "Библиотека",
    workouts: "Практики",
    lectures: "Разборы",
    courses: "Курсы",
    lives: "Трансляции",
    blog: "Статьи",
    becomeMember: "Вступай в клуб, чтобы получить доступ ко всем практикам! :)",
    coffee: "(месячная подписка по цене 2-х кофе)",
    saved: "Сохранённые Практики",
    loginToSeeSaved: "Войдите, чтобы увидеть сохранённые практики.",
    noSavedYet: "У вас пока нет сохранённых практик.",
    browseLibrary: "Перейти в библиотеку",
    toSaveSome: "и сохранить практики.",
    noMatchFilters: "Нет сохранённых практик по выбранным фильтрам.",
  },
};

export const LiveTrans = {
  english: {
    header: "Live Recordings",
    saved: "Saved Practices",
  },
  russian: {
    header: "Записи трансляций",
    saved: "Сохранённые Практики",
  },
};

export const WorkoutTrans = {
  english: {
    any: "Any",
    anyFem: "Any",
    type: "Type",
    level: "Level",
    duration: "Duration",
    beginner: "Beginner",
    experienced: "Experienced",
    advanced: "Advanced",
    recovery: "Recovery",
    progression: "Progression",
    fifteen: "15min",
    thirty: "30min",
    sixty: "60min",
    ninety: "90min",
  },
  russian: {
    any: "Любой",
    anyFem: "Любая",
    type: "Тип",
    level: "Уровень",
    duration: "Длительность",
    beginner: "Начинающий",
    experienced: "Опытный",
    advanced: "Продвинутый",
    recovery: "Восстановление",
    progression: "Развитие",
    fifteen: "15мин",
    thirty: "30мин",
    sixty: "60мин",
    ninety: "90мин",
  },
};

export const OnlineSessionsTrans = {
  english: {
    header: "Schedule",
    liveLessons: "All classes",
    nextLiveSession: "Next online session is on: "
  },
  russian: {
    header: "Расписание и запись",
    liveLessons: "Все занятия:",
    nextLiveSession: "Онлайн практики: "
  },
};

export const ConstructorTrans = {
  english: {
    header: "Create your own workout",
    trialHeader: "Try the Practice Builder",
    trialFullVersionBefore1: "For the full version, join the ",
    trialLinkOnlineClub: "Online Club",
    trialFullVersionBetween: " or become a member of ",
    trialLinkSchedule: "studio",
    trialFullVersionEnd: " with a multipass.",
    iWantToWorkOn: "I want to work on:",
    workoutReady: "Your custom practice is ready. Enjoy!",
    previous: "←",
    next: "→",
    player: "Player",
    sourceYoutube: "YouTube",
    sourceAlternative: "Alternative",
    tags: "Tags",
    description: "The practice-building algorithm is trained to organize blocks in a physiologically and biomechanically sound sequence, so you can trust it. Blocks will auto-advance. Enjoy! ❤",
  },
  russian: {
    header: "Создай свою тренировку",
    trialHeader: "Пробный конструктор практики",
    trialFullVersionBefore1: "Для полной версии присоединяйтесь к ",
    trialLinkOnlineClub: "онлайн-клубу",
    trialFullVersionBetween: " или к ",
    trialLinkSchedule: "студии",
    trialFullVersionEnd: " с абонементом.",
    iWantToWorkOn: "Я хочу поработать над:",
    workoutReady: "Твоя тренировка готова",
    previous: "←",
    next: "→",
    player: "Плеер",
    sourceYoutube: "YouTube",
    sourceAlternative: "Альтернатива",
    tags: "Теги",
    description: "Алгоритм построения практики обучен выстраивать блоки в грамотной последовательности с точки зрения физиологии и биомеханики, так что можешь ему довериться. Блоки будут перелистываться автоматически. Наслаждайся! ❤",
  },
};

export const ButtonsTrans = {
  english: {
    complete: "Completed",
    markAsComplete: "Mark as complete",
    saved: "Saved",
    saveForLater: "Save for later",
    exploreMore: "TO LIBRARY",
    search: "Construct",
    random: "Random",
    buildAgain: "Build Again",
  },
  russian: {
    complete: "Выполнено",
    markAsComplete: "Выполнено",
    saved: "Сохранено",
    saveForLater: "Сохранить на потом",
    exploreMore: "К БИБЛИОТЕКЕ",
    search: "Построить",
    random: "Случайно",
    buildAgain: "Построить заново",
  },
};

export const TagListTrans = {
  english: {
    balance: "balance",
    twists: "twists",
    splits: "splits",
    backBends: "back bends",
    armBalances: "arm balances",
    core: "core",
    backStrength: "back strength",
    handstands: "handstands",
    legStrength: "legs strength",
    armStrength: "arms strength",
    flexibility: "flexibility",
    breathing: "breathing",
    guidedShavasana: "guided Shavasana",
    hipOpeners: "hip openers",
    lotus: "lotus",
    surya: "surya namaskar",
    shoulders: "shoulders",
    chestOpeners: "chest openers",
    seated: "seated poses",
    laying: "supine",
    noInversions: "groundwork",
    glutes: "glutes",
  },
  russian: {
    balance: "балансы",
    twists: "здоровье поясницы",
    splits: "шпагаты",
    backBends: "прогибы",
    armBalances: "балансы на руках",
    core: "пресс",
    backStrength: "укрепление спины",
    handstands: "стойка на руках",
    legStrength: "укрепление ног",
    armStrength: "укрепление рук",
    flexibility: "гибкость",
    breathing: "дыхательные техники",
    guidedShavasana: "шавасана",
    hipOpeners: "тазобедренный сустав",
    lotus: "лотос",
    surya: "сурья намаскар",
    shoulders: "раскрытие плечей",
    chestOpeners: "раскрытие груди",
    seated: "сидя",
    laying: "лежа",
    noInversions: "женские дни",
    glutes: "укрепление ягодиц",
  },
};

export const FooterTrans = {
  english: {
    about: "About Studio",
    terms: "TERMS OF SERVICE",
    privacy: "PRIVACY POLICY",
    help: "HELP",
    contact: "Contacts",
    faq: "FAQ",
    schedule: "Schedule",
    library: "Library",
    pricing: "Pricing",
    yogaStudio: `Yoga Studio "Once up on a mat".`,
    rights: "© 2025 All rights reserved.",
    documents: "Documents",
    followUs: "Follow us",
    docPrivacy: "Privacy Policy",
    docTermsSales: "Terms (product sales)",
    docTermsService: "Terms (service provision)",
    docLicense: "License",
    poweredBy: "Powered by",
  },
  russian: {
    about: "О студии",
    terms: "ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ",
    privacy: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ",
    help: "ПОМОЩЬ",
    contact: "Контакты",
    faq: "ЧАВО",
    schedule: "Расписание",
    library: "Библиотека",
    pricing: "Абонементы",
    yogaStudio: `Йога студия "Однажды на коврике".`,
    rights: "© 2025 Все права защищены.",
    documents: "Документы",
    followUs: "Мы в соцсетях",
    docPrivacy: "Политика конфиденциальности",
    docTermsSales: "Условия (продажа товаров)",
    docTermsService: "Условия (оказание услуг)",
    docLicense: "Лицензия",
    poweredBy: "Работает на",
  },
};

export const ShopTrans = {
  english: {
    header: "Shop",
    description: "Yoga goodies",
    buy: "Buy",
    yogaMat: "Yoga Mat",
    incenseSticks: "Incense Sticks",
    henna: "Henna",
    blocks: "Yoga Blocks (2)",
  },
  russian: {
    header: "Магазин",
    description: "Йога ништяки",
    buy: "Купить",
    yogaMat: "Йога коврик",
    incenseSticks: "Благовония",
    henna: "Натуральная хна (конус)",
    blocks: "Кубики (2)",
  },
};

export const LoginTrans = {
  english: {
    signupHeader: "Sign Up",
    loginHeader: "Login",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    alreadySignedUp: "Already signed up?",
    notRegisteredYet: "Not registered yet?",
    forgotPassword: "Forgot password?",
  },
  russian: {
    signupHeader: "Регистрация",
    loginHeader: "Вход",
    email: "Эл.почта",
    password: "Пароль",
    confirmPassword: "Подтвердить пароль",
    alreadySignedUp: "Уже есть профиль?",
    notRegisteredYet: "Нет профиля?",
    forgotPassword: "Забыли пароль?",
  },
};

export const ChatbotTrans = {
  english: {
    chatbot: "Chatbot",
    header: "Send a message",
    inputPlaceholder: "Type a message...",
    sendButton: "Send",
    defaultResponse: "Hello! How can I assist you today?",
  },
  russian: {
    chatbot: "Чатбот",
    header: "Отправить сообщение",
    inputPlaceholder: "Привет!..",
    defaultResponse: "Hello! How can I assist you today?",
    sendButton: "Пиу",
  },
};

export const ToasterTrans = {
  english: {
    login: "Please log in to try this out!",
    premium: "Please upgrade to try this out!",
    comingSoon: "Coming soon! ♥",
    invalidEmail: "Please enter a valid email.",
    subscribed: "Subscribed successfully!",
    subscribeError: "Subscription failed. Please try again later",
    alreadySubscribed: "You're already subscribed! :)",
    referralSaved: "Referral code saved.",
    coursePurchased: "Payment successful — course unlocked! 🎉",
  },
  russian: {
    login: "Войди, чтобы попробовать эту фичу! ♥",
    premium: "Подпишись, чтобы попробовать эту фичу!",
    comingSoon: "Скоро будет! ♥",
    invalidEmail: "Проверьте, корректен ли email",
    subscribed: "Подписка успешна!",
    subscribeError: "Произошла ошибка. Попробуйте еще раз позже",
    alreadySubscribed: "Вы уже подписаны! :)",
    referralSaved: "Реферальный код сохранён.",
    coursePurchased: "Оплата прошла успешно — курс открыт! 🎉",
  },
};

export const PWAInstallTrans = {
  english: {
    message: "Install the app for quick access from your home screen.",
    install: "Install app",
    dismiss: "Not now",
    iosHint: "Tap Share → Add to Home Screen to install.",
  },
  russian: {
    message: "Установите приложение для быстрого доступа с главного экрана.",
    install: "Установить приложение",
    dismiss: "Позже",
    iosHint: "Нажмите «Поделиться» → «На экран Домой», чтобы установить как приложение.",
  },
};

export const ProfileTrans = {
  english: {
    header: "Profile",
    logout: "Logout",
    profile: "Profile",
    save: "Save",
    community: "Community",
    support: "Support",
    changePlan: "Change",
    classes: "Classes",
    currentPlan: "Current Plan",
    completedClasses: "Classes Completed:",
    savedClasses: "Saved Classes:",
    telegramChat: "Telegram Chat",
    contactSupport: "Contact Support ",
    comingSoon: "Coming Soon",
    memberSince: "Member since:",
    intensity: "Intensity",
    onSightEvents: "On-site Events",
    onlineEvents: "Online Events",
    nothingPlanned: "No upcoming events",
    chat: "Chat",
    myPasses: "My passes",
    pastPasses: "Past passes",
    passExhausted: "All classes used",
    paused: "Paused",
    upcomingBookings: "Upcoming bookings",
    viewSchedule: "View schedule",
    bookAClass: "Book a class",
    noUpcomingBookings: "No upcoming classes",
    subscriptionActive: "Active",
    subscriptionCancelled: "Cancelled",
    subscriptionCancelledNote: "Subscription cancelled",
    subscriptionPast: "Past subscription",
    nextBilling: "Next billing",
    accessUntil: "Access until",
    endedOn: "Ended on",
    mySubscriptions: "My subscriptions",
    noSubscription: "No active subscription",
    practiceScore: "Practices",
    practiceScoreOne: "Practice",
    yourScore: "Your journey",
    pastBookings: "Past classes",
    noPastBookings: "No past classes yet",
    otherBookings: "Other bookings",
    classesCount: "classes",
    levelBeginner: "Beginner",
    levelRegular: "Regular",
    levelDevoted: "Devoted",
    levelLegend: "Legend",
    toNextLevel: "to next level",
    youAreLegend: "You're a Legend!",
    status: "Status",
    email: "Email",
    subscribe: "Join Online Club",
    regularDaysLabel: "My regular days",
    regularDaysHint: "Classes on these days will be auto-booked when you have an active pass.",
    unpaidPass: "Unpaid",
    payForPass: "Pay",
    activateGiftCode: "Activate gift code",
    activateGiftPlaceholder: "Enter code",
    activateGiftButton: "Activate",
    activateGiftLoginHint: "Log in to activate your code.",
    goToScheduleNote: "Go to schedule to book classes",
    referFriendTitle: "Refer a friend",
    referFriendHint:
      "Share this link. When they buy a multi-class pass or subscription, you get one free class pass.",
    referFriendCopy: "Copy link",
    referFriendCopied: "Copied!",
  },
  russian: {
    header: "Профиль",
    logout: "Выйти",
    profile: "Профиль",
    save: "Cохранить",
    community: "Сообщество",
    support: "Поддержка",
    changePlan: "Отменить подписку",
    classes: "Практики",
    currentPlan: "Текущий план",
    completedClasses: "Завершенные практики: ",
    savedClasses: "Перейти к сохраненным практикам: ",
    telegramChat: "Телеграм чат",
    contactSupport: "Связаться с поддержкой ",
    comingSoon: "Скоро",
    memberSince: "На коврике с:",
    intensity: "Интенсивность",
    onSightEvents: "Живые Мероприятия",
    onlineEvents: "Онлайн Мероприятия",
    nothingPlanned: "Нет запланированных мероприятий",
    chat: "канал",
    subscribe: "Присоединиться к Онлайн Клубу",
    myPasses: "Мои абонементы",
    pastPasses: "Прошлые абонементы",
    passExhausted: "Использован",
    paused: "Заморожен",
    upcomingBookings: "Предстоящие занятия",
    viewSchedule: "Расписание",
    bookAClass: "Записаться на занятие",
    noUpcomingBookings: "Нет предстоящих занятий",
    subscriptionActive: "Активна",
    subscriptionCancelled: "Отменена",
    subscriptionCancelledNote: "Подписка отменена",
    subscriptionPast: "Прошедшая подписка",
    nextBilling: "Следующее списание",
    accessUntil: "Доступ до",
    endedOn: "Завершена",
    mySubscriptions: "Мои подписки",
    noSubscription: "Нет активной подписки",
    practiceScore: "Практик",
    practiceScoreOne: "Практика",
    practiceScoreFew: "Практики",
    practiceScoreMany: "Практик",
    yourScore: "Твой путь",
    pastBookings: "Прошедшие занятия",
    noPastBookings: "Пока не было занятий",
    otherBookings: "Другие записи",
    classesCount: "занятий",
    levelBeginner: "Исследователь",
    levelRegular: "Практикующий",
    levelDevoted: "Йогин",
    levelLegend: "Легенда",
    toNextLevel: "до следующего уровня",
    youAreLegend: "Ты Легенда!",
    status: "Статус",
    email: "Email",
    regularDaysLabel: "Постоянные дни",
    regularDaysHint: "На эти дни занятия в студии будут записываться автоматически, если у вас активный абонемент.",
    unpaidPass: "Неоплачен",
    payForPass: "Оплатить",
    activateGiftCode: "Активировать подарочный код",
    activateGiftPlaceholder: "Введите код",
    activateGiftButton: "Активировать",
    activateGiftLoginHint: "Войдите в аккаунт, чтобы активировать код.",
    goToScheduleNote: "Перейти в расписание, чтобы записаться на занятие",
    referFriendTitle: "Рефералка",
    referFriendHint: "При покупке абонемента на несколько занятий по вашей рекомендации вы получите бесплатный урок.",
    referFriendCopy: "Скопировать ссылку",
    referFriendCopied: "Скопировано!",
  },
};

/**
 * Returns the practice count label with correct plural form.
 * Russian: практика (1, 21, 31...), практики (2-4, 22-24...), практик (0, 5-20, 25-30...).
 * English: "Practice" (1), "Practices" (other).
 */
export function getPracticeScoreLabel(count, language) {
  const n = Math.abs(Number(count)) % 100;
  const n10 = n % 10;
  if (language === "russian") {
    if (n10 === 1 && n !== 11) return ProfileTrans.russian.practiceScoreOne;
    if (n10 >= 2 && n10 <= 4 && (n < 10 || n >= 20)) return ProfileTrans.russian.practiceScoreFew;
    return ProfileTrans.russian.practiceScoreMany;
  }
  return Number(count) === 1 ? ProfileTrans.english.practiceScoreOne : ProfileTrans.english.practiceScore;
}

export const DaysOfTheWeekTrans = {
  english: {
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    january: "Jan",
    february: "Feb",
    march: "Mar",
    april: "Apr",
    may: "May",
    june: "Jun",
    july: "Jul",
    august: "Aug",
    september: "Sep",
    october: "Oct",
    november: "Nov",
    december: "Dec",
  },
  russian: {
    sunday: "Воскресенье",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sun: "Вс",
    mon: "Пн",
    tue: "Вт",
    wed: "Ср",
    thu: "Чт",
    fri: "Пт",
    sat: "Сб",
    january: "Янв",
    february: "Фев",
    march: "Мар",
    april: "Апр",
    may: "Май",
    june: "Июн",
    july: "Июл",
    august: "Авг",
    september: "Сен",
    october: "Окт",
    november: "Ноя",
    december: "Дек",
  },
};

/** Month keys for indexing (0 = january, ...). Use with DaysOfTheWeekTrans[language]. */
const MONTH_KEYS = [
  'january', 'february', 'march', 'april', 'may', 'june',
  'july', 'august', 'september', 'october', 'november', 'december'
];

/** Map short month (Jan, Feb, ...) to DaysOfTheWeekTrans key. */
const MONTH_ABBR_TO_KEY = {
  jan: 'january', feb: 'february', mar: 'march', apr: 'april', may: 'may', jun: 'june',
  jul: 'july', aug: 'august', sep: 'september', oct: 'october', nov: 'november', dec: 'december'
};

/**
 * Translate a short month string (e.g. "Jan", "Feb") using daysTrans (DaysOfTheWeekTrans[language]).
 * @param {string} monthAbbr - From format(date, 'MMM') or toLocaleDateString(..., { month: 'short' })
 * @param {object} daysTrans - DaysOfTheWeekTrans[language]
 * @returns {string} Translated month
 */
export function translateMonth(monthAbbr, daysTrans) {
  if (!monthAbbr) return monthAbbr;
  const key = MONTH_ABBR_TO_KEY[String(monthAbbr).toLowerCase().slice(0, 3)];
  return key && daysTrans ? (daysTrans[key] ?? monthAbbr) : monthAbbr;
}

/**
 * Get translated month name for a date (for calendar headers, etc.).
 * @param {Date} date
 * @param {object} daysTrans - DaysOfTheWeekTrans[language]
 * @returns {string}
 */
export function getTranslatedMonthFromDate(date, daysTrans) {
  if (!date || !daysTrans) return '';
  return daysTrans[MONTH_KEYS[new Date(date).getMonth()]] ?? '';
}

/**
 * Format date as "dd MMM yyyy" with month translated (e.g. "23 Feb 2025" or "23 Фев 2025").
 * @param {Date|string|number} date
 * @param {object} daysTrans - DaysOfTheWeekTrans[language]
 * @returns {string|null}
 */
export function formatDateLocalized(date, daysTrans) {
  if (!date || !daysTrans) return null;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const day = String(d.getDate()).padStart(2, '0');
  const monthAbbr = d.toLocaleDateString('en-GB', { month: 'short' });
  const monthTrans = translateMonth(monthAbbr, daysTrans);
  const year = d.getFullYear();
  return `${day} ${monthTrans} ${year}`;
}

export const BlogTrans = {
  english: {
    header: "Blog",
    newsLetter: "Subscribe to Our Newsletter",
    subscribeSubText: "Get the latest yoga insights and tips straight to your inbox.",
    subscribe: "Subscribe",
    email: "Enter your email",
    all: "All",
    tips: "Tips",
    readMore: "Read More →",
    return: "← Back",
    inspo: "Inspo",
  },
  russian: {
    header: "Статьи",
    newsLetter: "Подписаться На Рассылку",
    subscribeSubText: "Получайте свежие советы и инсайты о йоге прямо на свою почту 📩",
    subscribe: "Подписаться",
    email: "Введите свою почту",
    all: "Все",
    tips: "Полезности",
    readMore: "Читать дальше →",
    return: "← Вернуться",
    inspo: "Вдохновение",
  },
};

export const SuccessTrans = {
  english: {
    payment: "Payment Successful!",
    yourSub: "Your subscription is now ",
    active: "active",
    welcome: ". Welcome aboard!",
    firstStep: "First step complete! Now all that's left is to roll out your mat and leave it in place. It's now part of your physical and mental space—your gathering point. Return to it whenever you wish, and we'll be there with you.",
    whatsAvailable: "📦 Here's what you have access to:",
    liveLessonsDescription: "We meet every week for a live online lesson.",
    liveLessonsExtra: "Please keep your camera on and your display name legible so I can address you personally and help you build a safe, effective asana. The joining link will be pinned in the chat.",
    liveLessonsButton: "Lesson Recordings",
    libraryButton: "Open Library",
    constructorButton: "Go to Practice Builder",
    chatButton: "Join the Chat",
    successOnlineClubPrivateChatButton: "Private chat",
    successOnlineClubGoButton: "Go",
    chatExtra: "A private support chat for club members. We'll discuss yoga nuances, health, and lifestyle.",
    constructorExtra: "With our trained algorithm you can craft a practice that's both safe and effective. Choose intensity, duration, and focus for your session!",
    account: "Your Account",
    plan: "Plan",
    started: "Started",
    nextPayment: "Next Payment",
    planToggleSubscription: "Subscription",
    planToggleSingle: "Single class",
  },
  russian: {
    payment: "Оплата прошла успешно!",
    yourSub: "Ваша подписка теперь",
    active: " активна",
    welcome: ". Добро пожаловать на борт!",
    firstStep: "Первый шаг пройден! Дело за малым - расстелить коврик и не убирать его. Теперь это часть вашего физического и ментального пространства, точка сборки. Возвращайтесь на него так часто, как хочется, а мы составим компанию.",
    whatsAvailable: "📦 Что вам доступно:",
    liveLessonsDescription: "Каждую неделю встречаемся на онлайн уроке.",
    liveLessonsExtra: "На занятии нужна включенная камера и читабельное имя, чтобы я могла обратиться к вам лично и помочь выстроить безопасную и эффективную асану. Ссылка на подключение будет закреплена в чате.",
    liveLessonsButton: "Записи трансляций",
    libraryButton: "Открыть библиотеку",
    constructorButton: "Перейти к конструктору",
    chatButton: "Вступить в чат",
    successOnlineClubPrivateChatButton: "Закрытый чат",
    successOnlineClubGoButton: "Перейти",
    chatExtra: "Закрытый чат поддержки членов клуба. Обсудим тонкости йоги, здоровье и образ жизни",
    constructorExtra: "С помощью обученного алгоритма ты можешь создать практику, сохранив безопасность и эффективность последовательности. Выбирай степень нагрузки, длительность и акцент занятия!",
    account: "Ваш аккаунт",
    plan: "План",
    started: "Старт",
    nextPayment: "Следующее списание",

    registration: "Подписка на Онлайн Клуб ♡",
    welcome2: "Добро пожаловать!",
    planToggleSubscription: "Подписка",
    planToggleSingle: "Разовое занятие",
    membership: "Подписка в нашем клубе стоит ≈ 50 € в месяц (к оплате 200₪ или 5000₽) — без скрытых комиссий и дополнительных платежей. Я хотела сделать цену доступной для всех, но не настолько низкой, чтобы про подписку можно было забыть и не заниматься. Списания происходят автоматически раз в месяц со дня оформления. Вы можете отменить подписку в любой момент в личном кабинете, а также посмотреть дату следующего списания.",
    dust: "Сдуваем пыль с ковриков и ...",
    interCard: "Карта Израиля и других стран",
    rusCard: "Карта РФ",

  },
};

export const NotFoundTrans = {
  english: {
    title: "Page not found",
    subtitle: "This page doesn't exist or you don't have access to it.",
    backHome: "Back to home",
    backLibrary: "Go to library",
  },
  russian: {
    title: "Страница не найдена",
    subtitle: "Этой страницы не существует или у вас нет к ней доступа.",
    backHome: "На главную",
    backLibrary: "В библиотеку",
  },
};

export const ScheduleTrans = {
  english: {
    loading: "Loading classes...",
    noClasses: "No classes scheduled",
    liveLessons: "Schedule",
    upcomingClasses: "Upcoming Group Classes",
    week: "Week",
    booked: "Booked ✓",
    bookedOnline: "Booked online ✓",
    bookLabelStudio: "Studio",
    bookLabelPark: "Park",
    parkTemporaryStudioNotice:
      '“Park” classes temporarily take place at the studio due to martial law.',
    bookLabelOnline: "Online",
    videoCallLink: "Join video call",
    bookSpotInStudio: "Book a spot (in studio)",
    joinOnline: "Join online",
    book: "Book",
    today: "Today",
    min: "min",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    morningPracticeHeader: "Morning Practices",
    eveningPracticeHeader: "Evening Practices",
    bookClass: "Book Class:",
    confirmBooking: "Confirm Booking",
    booking: "Booking...",
    loadingDotDotDot: "Loading...",
    bookingSuccess: "✓ Booking successful!",
    bookingError: "✗ Booking failed. Try again.",
    studioFullCannotSwitch: "Studio is full.",
    studioFullJoinOnline: "No spots in studio, but you can join online",
    notifyMe: "Notify me if a spot opens up",
    onWaitingList: "You're on the waiting list",
    leaveWaitingList: "Remove me",
    waitlistJoined: "You'll be notified if a spot opens up!",
    waitlistLeft: "Removed from waiting list",
    fullyBookedStudio: "No spots available",
    prices: "Price List:",
    trial: "Trial class",
    park: "Park class",
    dropInClass: "Drop-in class",
    basicPass: "Once Up on a Mat",
    standartPass: "Twice Up on a Mat",
    limitless: "Always on the Mat",
    onlineClub: "Online Club",
    "individual-1": "Individual – 1 class",
    "individual-4": "Individual – 4 classes",
    "individual-8": "Individual – 8 classes",
    "individual-12": "Individual – 12 classes",
    scheduleTogglerStudio: "Studio",
    january: "Jan",
    february: "Feb",
    march: "Mar",
    april: "Apr",
    may: "May",
    june: "Jun",
    july: "Jul",
    august: "Aug",
    september: "Sep",
    october: "Oct",
    november: "Nov",
    december: "Dec",
    parkLeumi: "Park Leumi",
    studio: "Studio",
    ramatGanRooftop: "Ramat Gan Rooftop",
    cancelled: "Cancelled",
    confirmCancel: "Confirm Cancel",
    keepBooking: "Keep Booking",
    cancelBooking: "Cancel Booking",
    classesUsed: "classes used",
    unlimited: "Unlimited Classes",
    expiresOn: "Expires on",
    expiredAt: "Expired at",
    paused: "Paused",
    noActivePass: "No active pass - purchase one to book classes",
    bookingCancelled: "Booking cancelled",
    bookingCancelledError: "Failed to cancel booking",
    buyNow: "Buy now",
    onlineClubAlreadyHavePass: "You already have an active Online Club pass. Book classes from the calendar above.",
    learnAboutOnlineClub: "Learn about Online Club",
    comingSoon: "Coming soon! ♥",
    selectPass: "Select a Pass",
    confirmPurchase: "Confirm Purchase",
    logIn: "Log in",
    passDoesNotCoverDate: "Your current pass doesn't cover this date. Please purchase a new pass.",
    passBookAfterSubscriptionRenews:
      "You can book this class after your subscription renews.",
    passRenewWhenSubscriptionEnds:
      "You can renew your pass when the subscription period ends.",
    passExhausted: "You've used all classes in your current pass. Please purchase a new one.",
    purchasePassToBook: "Purchase a pass to book this class.",
    passNotValidForPark: "Your current pass is not valid for park classes. Please purchase a park, basic, standard, or limitless pass.",
    passNotValidForStudio: "Park pass cannot be used for studio classes. Please purchase a different pass.",
    passNotValidForOnlineClub: "Your current pass is not valid for Online Club classes. Purchase an Online Club pass to book.",
    passOnlineClubOnlyForOnline: "Online Club pass can only be used for online classes. Purchase a studio pass to book in-person classes.",
    cannotCancelWithin12Hours: "Bookings cannot be cancelled less than 8 hours before class",
    oneTimePurchase: "One-time Purchase",
    validForMonth: "Valid for one month",
    subscribe: "Subscribe",
    autoRenewsMonthly: "Auto-renews monthly",
    month: "month",
    subscriptionInfo: "Your subscription will renew automatically every month. You can cancel anytime from your account.",
    subscriptionOnlyNotice: "This pass is only available as a subscription.",
    paymentSuccess: "Payment successful! Your pass has been purchased.",
    nextBillingDate: "Next billing",
    activeSubscriptionMessage: "You have an active subscription. You can only purchase single-class passes.",
    oneTimePurchaseOnly: "One-time purchase only",
    needToLogin: "Please log in to book a class",
    loginToBook: "Login to Book",
    joinCommunity: "Join our community",
    joinStudioChat: "Join the studio chat",
    joinClubChat: "Join the club chat",
    closedClubChat: "Members-only club chat",
    whatsappGroup: "WhatsApp Group",
    telegramChannel: "Telegram channel",
    discountValidUntil: "Discounts valid until",
    schedulePricingSavings: "Savings",
    schedulePricingTrialTitle: "Trial · Park",
    schedulePricingTrialDes:
      "Trial class in the studio or a one-time park class",
    schedulePricingValidityNote: "Passes are valid for 30 days.",
    processingPayment: "Processing your payment...",
    firstPassRulesLabelPrefix: "I have read and agree to the ",
    firstPassRulesLinkText: "studio rules and cancellation policy",
    rulesAndPoliciesLink: "Studio rules and cancellation policy",
    firstPassRulesAgreementRequired: "Please agree to the studio rules before purchasing your first pass.",
    firstPassRulesTitle: "Studio rules and cancellation policy",
    firstPassRulesContent: "Studio rules and cancellation policy will be displayed here. You can edit this text in the app translations (firstPassRulesContent).\n\nCancellation: Please cancel at least 8 hours before class. Late cancellations may be counted as used.",
    unpaidPasses: "Unpaid passes",
    payForPass: "Pay",
    individualClassesTitle: "Individual sessions",
    individualClassesSubtitle: "One-on-one yoga with a teacher. Choose a pass and pay securely online.",
    individualClassesBuy: "Purchase",
    individualClassesLoginToBuy: "Log in to purchase",
    individualClassesValidDays: "Valid 30 days",
    individualClassesClasses: "classes",
  },
  russian: {
    loading: "Загрузка классов...",
    noClasses: "Нет запланированных занятий",
    liveLessons: "Расписание",
    upcomingClasses: "Предстоящие занятия",
    week: "Неделя",
    booked: "✓ Запись",
    bookedOnline: "✓ Запись онлайн",
    bookLabelStudio: "Студия",
    bookLabelPark: "Парк",
    parkTemporaryStudioNotice:
      'Временно проходят в студии в связи с военным положением',
    bookLabelOnline: "Онлайн",
    videoCallLink: "Ссылка на урок",
    bookSpotInStudio: "Место в студии",
    joinOnline: "Присоединиться онлайн",
    book: "Записаться",
    today: "Сегодня",
    min: "мин",
    sun: "Вс",
    mon: "Пн",
    tue: "Вт",
    wed: "Ср",
    thu: "Чт",
    fri: "Пт",
    sat: "Сб",
    morningPracticeHeader: "Утренние",
    eveningPracticeHeader: "Вечерние",
    bookClass: "Занятие:",
    confirmBooking: "Записаться",
    booking: "Записываю...",
    loadingDotDotDot: "Загрузка...",
    bookingSuccess: "✓ Запись успешна!",
    bookingError: "✗ Ошибка записи. Попробуйте снова.",
    studioFullCannotSwitch: "Мест в студии нет :'(",
    studioFullJoinOnline: "Мест в студии нет, но можно присоединиться онлайн",
    notifyMe: "Сообщите, если место освободится",
    onWaitingList: "Вы в листе ожидания",
    leaveWaitingList: "Убрать меня",
    waitlistJoined: "Вы в листе ожидания!",
    waitlistLeft: "Убрали из листа ожидания",
    fullyBookedStudio: "Мест нет",
    prices: "Цены:",
    trial: "Пробное занятие",
    park: "Занятие в парке",
    dropInClass: "Разовое занятие в студии",
    basicPass: "Однажды на коврике",
    standartPass: "Дважды на коврике",
    limitless: "Постоянно на коврике",
    onlineClub: "Онлайн клуб",
    "individual-1": "Индивидуальное – 1 занятие",
    "individual-4": "Индивидуальное – 4 занятия",
    "individual-8": "Индивидуальное – 8 занятий",
    "individual-12": "Индивидуальное – 12 занятий",
    scheduleTogglerStudio: "Студия",
    january: "Янв",
    february: "Фев",
    march: "Мар",
    april: "Апр",
    may: "Май",
    june: "Июн",
    july: "Июл",
    august: "Авг",
    september: "Сен",
    october: "Окт",
    november: "Ноя",
    december: "Дек",
    parkLeumi: "Парк Леуми",
    ramatGanRooftop: "Крыша в Рамат-Гане",
    studio: "Студия",
    cancelled: "Отменено",
    confirmCancel: "Галя, отмена",
    keepBooking: "Оставить",
    cancelBooking: "Отменить",
    classesUsed: "занятий использовано",
    unlimited: "Неограниченные занятия",
    expiresOn: "Истекает",
    expiredAt: "Истек",
    paused: "Заморожен",
    noActivePass: "Приобретите абонемент или разовое занятие для записи",
    bookingCancelled: "Бронирование отменено",
    bookingCancelledError: "Не удалось отменить бронирование",
    selectPass: "Выберите абонемент",
    buyNow: "Приобрести",
    onlineClubAlreadyHavePass: "У вас уже есть активный абонемент онлайн-клуба. Записывайтесь на занятия в расписании выше.",
    learnAboutOnlineClub: "Узнать об онлайн-клубе",
    comingSoon: "Скоро будет! ♥",
    confirmPurchase: "Приобрести",
    logIn: "Войти",
    passDoesNotCoverDate: "Ваш текущий абонемент не действует на эту дату",
    passBookAfterSubscriptionRenews:
      "Вы сможете записаться на занятие после обновления абонемента",
    passRenewWhenSubscriptionEnds:
      "Вы сможете обновить абонемент по окончанию действия подписки",
    passExhausted: "Вы использовали все занятия в текущем абонементе",
    purchasePassToBook: "Выберите абонемент для записи",
    passNotValidForPark:
      "Ваш текущий абонемент не подходит для занятий в парке. Оформите абонемент для парка, basic, standard или limitless.",
    passNotValidForStudio: "\"Занятие в парке\" не действует для занятий в студии",
    passNotValidForOnlineClub: "Ваш текущий абонемент не подходит для онлайн-клуба. Оформите абонемент онлайн-клуба, чтобы записаться.",
    passOnlineClubOnlyForOnline: "Абонемент онлайн-клуба действует только на онлайн-занятия.",
    cannotCancelWithin12Hours: "Запись нельзя отменить менее чем за 8 часов до занятия",
    oneTimePurchase: "Одноразовая покупка",
    validForMonth: "Действует месяц",
    subscribe: "Подписка",
    autoRenewsMonthly: "Автоматическое продление каждый месяц",
    month: "месяц",
    subscriptionInfo: "Абонемент автоматически продлится в следующем месяце. Вы можете отменить подписку в любой момент в личном кабинете.",
    subscriptionOnlyNotice: "Этот абонемент доступен только по подписке.",
    paymentSuccess: "Платёж прошёл успешно! Ваш абонемент куплен.",
    nextBillingDate: "Обновится",
    activeSubscriptionMessage: "У вас есть активная подписка. Вы можете приобретать только разовые занятия.",
    oneTimePurchaseOnly: "Только разовая покупка",
    needToLogin: "Пожалуйста, войдите в систему, чтобы записаться на занятие",
    loginToBook: "Войти для записи",
    joinCommunity: "Присоединиться к сообществу",
    joinStudioChat: "Чат студии",
    joinClubChat: "Открытое комьюнити",
    closedClubChat: "Закрытый чат клуба",
    whatsappGroup: "WhatsApp группа",
    telegramChannel: "Канал в Telegram",
    discountValidUntil: "Скидки действуют до",
    schedulePricingSavings: "Экономия",
    schedulePricingTrialTitle: "Пробное · Парк",
    schedulePricingTrialDes:
      "Пробное занятие в студии или разовое в парке",
    schedulePricingValidityNote: "Срок действия абонементов — 30 дней.",
    processingPayment: "Обрабатываем платёж...",
    firstPassRulesLabelPrefix: "Я ознакомился(ась) с ",
    firstPassRulesLinkText: "правилами студии и политикой отмены",
    rulesAndPoliciesLink: "Правила студии и политика отмены",
    firstPassRulesAgreementRequired: "Пожалуйста, примите правила студии перед покупкой первого абонемента.",
    firstPassRulesTitle: "Правила студии и политика отмены",
    firstPassRulesContent: "Здесь отображаются правила студии и политика отмены. Текст можно изменить в переводах приложения (firstPassRulesContent).\n\nОтмена: отменяйте запись не позднее чем за 8 часов до занятия. Поздние отмены могут считаться использованными.",
    unpaidPasses: "Неоплаченные абонементы",
    payForPass: "Оплатить",
    individualClassesTitle: "Индивидуальные занятия",
    individualClassesSubtitle: "Йога один на один с преподавателем. Выберите абонемент и оплатите онлайн.",
    individualClassesBuy: "Приобрести",
    individualClassesLoginToBuy: "Войдите, чтобы приобрести",
    individualClassesValidDays: "Действует 30 дней",
    individualClassesClasses: "занятий",
  },
};

/** Individual classes landing page (design from individual.html) */
export const IndividualTrans = {
  english: {
    eyebrow: "One-to-one yoga",
    heroTitle: "Practice built around",
    heroTitleEm: "your",
    heroTitleSuffix: " body",
    heroSub: "No shared choreography — one mat, one teacher, and the only body that matters: yours. Each session is paced and shaped for your goals, limits, and curiosity.",
    heroScroll: "Scroll to explore",
    badge1: "Studio · Ramat Gan",
    badge2: "Live online · Zoom",
    badge3: "~90 min sessions",
    forWhomLabel: "Who it's for",
    forWhomKicker: "Four reasons people choose private sessions",
    forWhomTitle: "Individual means",
    forWhomTitleEm: "made for you",
    forWhom1Num: "01",
    forWhom1Title: "Injuries & limitations",
    forWhom1Text: "Old injuries, back pain, post-surgery or rehab. In a group, practice often shrinks to “safe defaults.” One-on-one, we rebuild from your actual range — I know how bodies break and how they come back.",
    forWhom2Num: "02",
    forWhom2Title: "A clear goal",
    forWhom2Text: "Handstand, deep folds, spine ease, hips — or something only you can name. Instead of a one-size sequence, you get a path from A to B with a reason behind every session.",
    forWhom3Num: "03",
    forWhom3Title: "Starting from zero",
    forWhom3Text: "Group class can feel loud or fast. If you want to learn foundations in private first — or combine 1:1 with group later — this is the gentlest on-ramp.",
    forWhom4Num: "04",
    forWhom4Title: "Stuck on a plateau",
    forWhom4Text: "You already practice but progress stalled. Private work gives what groups rarely can: a teacher’s eyes on your patterns, and drills aimed exactly where you’re leaking effort.",
    requestsEyebrow: "What we work on",
    requestsTitle: "What brings people here",
    requests1Icon: "◆",
    requests1Text: "Skill & depth — hand balances, demanding asanas, splits, lotus, strength and mobility that actually transfers to life.",
    requests2Icon: "◇",
    requests2Text: "Health & tuning — how yoga touches body and nervous system. Practice adjusted to you, not the other way around.",
    requests3Icon: "○",
    requests3Text: "Vitality — feel lighter, stronger, more mobile and awake in everyday movement (without crash diets or gimmicks).",
    requests4Icon: "◎",
    requests4Text: "Downshift — relaxation, breath, meditation-style focus and pranayama. Grounded in physiology, not mysticism.",
    approachLabel: "My approach",
    approachTitle: "Not a fixed program —",
    approachTitleEm: "a dialogue",
    approachTitleSuffix: " with your body.",
    approachLead: "You’re not a slot on a spreadsheet. First sessions are discovery: how you move today, what hurts, what you’re hungry to change.",
    approachQuote: "Hands are the last tool a good teacher reaches for. Before that: voice, clear cues, and attention.",
    reviewLabel: "What students say",
    reviewAuthor: "Vitaliy",
    reviewParagraphs: [
      "I recently took a private yoga lesson, and it was a genuinely transformative experience. Thank you, Anya, for such a deep and attentive approach!",
      "It is not just a class — it is a space where the teacher truly senses the person and helps you understand your body and breath better. That meant a lot to me.",
      "After even the first session I felt calm, energy, and a clearer sense of how to work with my body.",
      "If you are looking for a professional who combines a personal approach with rich experience, I wholeheartedly recommend the “Once upon a mat” studio in Ramat Gan!",
      "It is exactly what you need to take your practice to the next level!",
    ],
    approach1Icon: "🔍",
    approach1Title: "First session is assessment",
    approach1Text: "We look at basic patterns, your history (injuries, surgery, chronic stuff), and what pulled you to the mat. A plan appears after listening, not before.",
    approach2Icon: "🧩",
    approach2Title: "Each session picks up where the last ended",
    approach2Text: "I track what worked, what felt stuck, what surprised us. The thread stays continuous — you’re not resetting to “generic yoga” every week.",
    approach3Icon: "🛡️",
    approach3Title: "Safety = clarity, not fear",
    approach3Text: "Rarely “just don’t.” Usually “here’s how to load this safely.” Most limits are puzzles — technique, patience, and the right progression.",
    approach4Icon: "📍",
    approach4Title: "Remote counts",
    approach4Text: "Camera stays on — I need to see you. Years of teaching online taught me what still reads clearly through a screen.",
    formatInPersonLabel: "In person",
    formatInPersonTitle: "Studio in Ramat Gan",
    formatInPersonText: "Jabotinsky, 103. Mamad studio — a protected space. Sessions aren't interrupted by alerts. Mat, props, cozy atmosphere — all there.",
    formatOnlineLabel: "Online",
    formatOnlineTitle: "Zoom from anywhere",
    formatOnlineText: "Home, travel, another timezone — same quality. Camera on is non‑negotiable for safe, useful feedback.",
    pricingLabel: "Invest in sessions",
    pricingTitle: "Pick a",
    pricingTitleEm: "pass",
    pricingNote: "30 days from your first booked session. Same rate whether we meet in the studio or on Zoom.",
    perSession: "per session",
    saving: "Save",
    popularChoice: "Popular choice",
    maxSaving: "Maximum savings",
    buy: "Purchase",
    loginToBuy: "Log in to purchase",
    sessionOne: "class",
    sessionFew: "classes",
    sessionMany: "classes",
    pricingFooter1: "Not sure where to start? Write on",
    pricingFooter2: "Questions about cancellation or rescheduling?",
    ctaTitle: "Curious?",
    ctaTitleEm: "Say hello.",
    ctaSub: "A few lines about you is enough — I usually answer within hours and we’ll sort format & timing together.",
    ctaButton: "WhatsApp",
    ctaEmail: "anna.joy.inbox@gmail.com",
    footerLogo: "Once upon a mat",
    footerCopy: "© 2025 All rights reserved",
    footerFormats: "All formats",
  },
  russian: {
    eyebrow: "Йога один на один",
    heroTitle: "Практика, построенная вокруг ",
    heroTitleEm: "вашего",
    heroTitleSuffix: " тела",
    heroSub: "Каждое занятие — под ваши цели, ваши возможности, ваш темп.",
    badge1: "Студия в Рамат-Гане",
    badge2: "Онлайн через Zoom",
    badge3: "1 час",
    forWhomLabel: "Запросы",
    forWhomKicker: "Четыре частых повода выбрать индивидуальный формат",
    forWhomTitle: "Индивидуально — значит ",
    forWhomTitleEm: "именно для вас",
    forWhom1Num: "01",
    forWhom1Title: "Травмы и ограничения",
    forWhom1Text: "Старая травма, боль в спине. В группе парктика адаптируется на избегание травмы — на индивидуальном мы работаем с травмами по возможности уменьшая их влияние на жизнь",
    forWhom2Num: "02",
    forWhom2Title: "Конкретная цель",
    forWhom2Text: "Шпагат, стойка на руках, здоровье позвоночника, мобильность — или что-то своё. Конкретный маршрут от точки А к точке Б, с понятной логикой каждого занятия.",
    forWhom3Num: "03",
    forWhom3Title: "Новички",
    forWhom3Text: "Вы не получаете всех ответов в группе? Хотите понять основы один на один, инидивдуальные занятия в дополнение к групповым могут помочь расставить все точки над и.",
    forWhom4Num: "04",
    forWhom4Title: "Плато в практике",
    forWhom4Text: "Вы уже занимаетесь, но чувствуете, что перестали расти. Индивидуальный формат даёт взгляд преподавателя именно на вас и работу над тем, где вы отстаёте.",
    approachLabel: "Мой подход",
    approachTitle: "Вне стнадартной программы. ",
    approachTitleEm: "Разговор",
    approachTitleSuffix: " с вашим телом.",
    approachLead: "Первое занятие — это всегда знакомство: чего вы хотите от практики, где ваше тело могло бы выдать больше свободы.",
    approachQuote: "Ни одно реальное тело невозможно втиснуть в идеальную асану. И пытаться это делать - частая ошибка. Напртив, каждая асана должна быть выстроена исключительно под ваше тело, чтобы оставаться безопасной и эффективной.",
    reviewLabel: "Отзыв",
    reviewAuthor: "Виталий",
    reviewParagraphs: [
      "Недавно я посетил индивидуальный урок по йоге, и это был по-настоящему трансформирующий опыт. Благодарю Аню за глубокий и внимательный подход!",
      "Это не просто занятие — это место, где учитель действительно чувствует человека и помогает лучше понять своё тело и дыхание. Для меня это было очень ценно.",
      "Уже после первой сессии я почувствовал спокойствие, энергию и чёткое понимание работы с телом.",
      "Если вы ищете профессионала, который сочетает индивидуальный подход и богатый опыт, искренне рекомендую студию «Однажды на коврике» в Рамат-Гане!",
      "Это именно то, что нужно, чтобы выйти на новый уровень в практике!",
    ],
    approach1Icon: "🔍",
    approach1Title: "Первое занятие — это диагностика",
    approach1Text: "Спрашиваю про историю тела — травмы, операции. Выясняю, что вас сюда привело. И к чему хотелось бы прийти. Только после этого складывается план.",
    approach2Icon: "🧩",
    approach2Title: "Каждое занятие логично вытекает из предыдущего",
    approach2Text: "Никакой случайности. Я помню, что мы делали в прошлый раз, где было сложно, что открылось. Мы работаем не над всем подряд, а над тем, что действительно важно для вас сейчас.",
    approach3Icon: "🛡️",
    approach3Title: "Безопасность — не осторожность, а точность",
    approach3Text: "Я не говорю «не делайте это». Я объясняю, как делать правильно. Любую асану можно подстроить под любое тело. И любое тело способно заниматься йогой. Большинство ограничений — не запреты, а задачи, с которыми можно работать.",
    approach4Icon: "📍",
    approach4Title: "Онлайн работает так же хорошо",
    approach4Text: "Включённая камера обязательна. Мне нужно вас видеть. Онлайн-формат не уступает очному. Руки - последний ресурс преподавателя йоги. Сначала голос, инструкция, взгляд.",
    formatInPersonLabel: "Очно",
    formatInPersonTitle: "Студия в Рамат-Гане",
    formatInPersonText: "Жаботинский, 103. Студия-мамад — защищённая комната. Коврик, пропсы, уютная атмосфера — всё есть.",
    formatOnlineLabel: "Онлайн",
    formatOnlineTitle: "Zoom из любой точки мира",
    formatOnlineText: "Дом, поездка, другой часовой пояс — качество то же. Без камеры честная и безопасная работа невозможна.",
    pricingLabel: "Абонементы",
    pricingTitle: "Выберите ",
    pricingTitleEm: "пакет",
    pricingNote: "30 дней с первого забронированного занятия.",
    perSession: "за занятие",
    saving: "Экономия",
    popularChoice: "Популярный выбор",
    maxSaving: "Максимальная экономия",
    buy: "Приобрести",
    loginToBuy: "Войдите, чтобы приобрести",
    sessionOne: "занятие",
    sessionFew: "занятия",
    sessionMany: "занятий",
    pricingFooter1: "Не уверены, с чего начать? Напишите в ",
    pricingFooter2: "Есть вопросы об отмене или переносе?",
    ctaTitle: "Хочется попробовать? ",
    ctaTitleEm: "Напишите.",
    ctaSub: "Пара строк о вас достаточно — обычно отвечаю в течение нескольких часов, вместе подберём формат и время.",
    ctaButton: "WhatsApp",
    ctaEmail: "anna.joy.inbox@gmail.com",
    footerLogo: "Однажды на коврике",
    footerCopy: "© 2025 Все права защищены",
    footerFormats: "Все форматы",
  },
};

/** "≈ X €" display price + the real charged amounts (see components/ui/ApproxPrice.jsx) */
export const PriceTrans = {
  english: {
    paidAs: "paid as",
    or: "or",
  },
  russian: {
    paidAs: "к оплате",
    or: "или",
  },
};


